import * as t from "./actionType";

export const callInboundList = (data) => ({ type: t.CALL_INBOUND_LIST, data });
export const callInboundListSuccess = (data) => ({ type: t.CALL_INBOUND_LIST_SUCCESS, data });
export const callInboundListFail = (data) => ({ type: t.CALL_INBOUND_LIST_FAIL, data });

export const callInboundListByCustomer = (data) => ({ type: t.CALL_INBOUND_LIST_BY_CUSTOMER, data });
export const callInboundListByCustomerSuccess = (data) => ({ type: t.CALL_INBOUND_LIST_BY_CUSTOMER_SUCCESS, data });
export const callInboundListByCustomerFail = (data) => ({ type: t.CALL_INBOUND_LIST_BY_CUSTOMER_FAIL, data });

export const callInboundData = (data) => ({ type: t.CALL_INBOUND_DATA, data });
export const callInboundDataSuccess = (data) => ({ type: t.CALL_INBOUND_DATA_SUCCESS, data });
export const callInboundDataFail = (data) => ({ type: t.CALL_INBOUND_DATA_FAIL, data });

export const callInboundCreate = (data) => ({ type: t.CALL_INBOUND_CREATE, data });
export const callInboundCreateSuccess = (data) => ({ type: t.CALL_INBOUND_CREATE_SUCCESS, data });
export const callInboundCreateFail = (data) => ({ type: t.CALL_INBOUND_CREATE_FAIL, data });
export const callInboundCreateReset = () => ({ type: t.CALL_INBOUND_CREATE_RESET });

export const callInboundUpdate = (data) => ({ type: t.CALL_INBOUND_UPDATE, data });
export const callInboundUpdateSuccess = (data) => ({ type: t.CALL_INBOUND_UPDATE_SUCCESS, data });
export const callInboundUpdateFail = (data) => ({ type: t.CALL_INBOUND_UPDATE_FAIL, data });
export const callInboundUpdateReset = () => ({ type: t.CALL_INBOUND_UPDATE_RESET });

export const callInboundDelete = (data) => ({ type: t.CALL_INBOUND_DELETE, data });
export const callInboundDeleteSuccess = (data) => ({ type: t.CALL_INBOUND_DELETE_SUCCESS, data });
export const callInboundDeleteFail = (data) => ({ type: t.CALL_INBOUND_DELETE_FAIL, data });
export const callInboundDeleteReset = () => ({ type: t.CALL_INBOUND_DELETE_RESET });
